import sanitizeHtml from 'sanitize-html'

export const sanitize = obj => {
  var result = {}
  for (var key in obj) {
    var value = obj[key]
    if (typeof value === "string") {
      result[key] = sanitizeHtml(value)
    } else if (typeof value === "object") {
      result[key] = sanitize(value)
    } else {
      result[key] = value
    }
  }
  return result
}



// WEBPACK FOOTER //
// ./src/utils/helpers/serializeJavascript.js